import callApi, { BaseResponseDto, callApiBlob } from "./baseRequest";
import moment from "moment";
const route = 'customers-survey';

export interface RequestReportData {
    customerIds: Array<string>,
    startDate: string,
    endDate: string,
    take: number,
    page: number,
    orderByColumnName: string,
    orderByDirection: string
}

export interface ResponseReportData {
    avgCsat: Array<ResponseReportDataAvg>,
    avgNps: Array<ResponseReportDataAvg>,
    avgCsatMonths: Array<ResponseReportDataAvgMonths>,
    avgNpsMonths: Array<ResponseReportDataAvgMonths>,
    tablePagesData: Array<ResponseReportDataTablePage>,
    tableData: Array<ResponseReportDataTable>
}

export interface ResponseReportDataAvg {
    average: number,
    count: number
}

export interface ResponseReportDataAvgMonths {
    average: number,
    year: number,
    month: number
}

export interface ResponseReportDataTablePage {
    totalItems: number,
    totalPages: number
}

export interface ResponseReportDataTable {
    customerId: string,
    customerName: string,
    userId: string,
    userEmail: string,
    npsScore: number,
    csatScore: number,
    comments: string,
    createdAt: string,
    looseAnswer: boolean
}

export function GetReportData(body: RequestReportData): Promise<BaseResponseDto<ResponseReportData>> {
    const result: BaseResponseDto<any> = {
        error: '',
        data: null,
        success: false
    };

    const response = callApi('POST', `${route}/report`, body)
    .then(resp => {
        if (resp?.error == null ?? false) {
            result.success = true;
            result.data = resp.data;
        }
        else {
            result.error = 'An error occurred while generating the report.';
        }
        return result;
    })
    .catch(err => {
        result.error = err;

        return result;
    })

    return response;
};

export function GetFileReport(body: RequestReportData, language: string) : Promise<boolean> {
    let url = `${route}/report/excel/${language}`;
    
    const p = callApiBlob(
        'POST',
        url,
        body
    )
    .then((resp) => {
        const blob = new Blob([resp as BlobPart], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const element = document.createElement('a');
        element.href = URL.createObjectURL(blob);
        element.download = `${moment().format('yyyy-MM-DD-HH-mm')}.xlsx`;
        document.body.appendChild(element);
        element.click();

        return true;
    })
    .catch(err => {
        return false;
    })

    return Promise.resolve(p);
};
